export default "__VITE_ASSET__CUmxQ7yH__"